export default __webpack_public_path__ + "static/media/login-logo.0e9f30cc.png";